module.exports = __webpack_public_path__ + "img/equipe-white.e31d6001.webp";